export default __webpack_public_path__ + "static/media/rightcaret.6af2ae4b.svg";